import axios from "axios";
import qs from 'qs';
import { TOKEN, URL, NOW } from '../utils/const';

export const planesContado = async (tr02100_id, imp_identificacion, tipo, setError) => {
  // const list = impApagar.map((obj) => {
  //   if (tipo === 'INM') return obj['value'].join(',')
  //   return Number(obj['value'])
  // }).toString();

  try {
    // console.log(tr02100_id);

    const responseOne = await axios({
      method: 'post',
      url: URL + 'planes_contado',
      data: qs.stringify({
        TOKEN: TOKEN,
        IMPONIBLE_ID: tr02100_id
      }),
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    });
    // console.log(responseOne.data);
    // console.log(responseOne.data.items[0].tr1p371_id);

    if (responseOne.data.error || responseOne.data.items.length === 0) throw new Error(responseOne.data);

    const d = new Date();
    d.setUTCDate(d.getUTCDate());

    const fecha_vec = d.toISOString().slice(0, 10); // YYYY-MM-DD
    // console.log(fecha_vec);
    const responseTwo = await axios({
      method: 'post',
      url: URL + 'plan_contado_recibo',
      data: qs.stringify({
        TOKEN: TOKEN,
        IMPONIBLE_ID: tr02100_id,
        TR1P371_ID: responseOne.data.items[0].tr1p371_id,
        FECHA_VENCIMIENTO: fecha_vec,
      }),
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    });
    // console.log(parseApexLikeResponse(responseTwo.data).error);
    if (parseApexLikeResponse(responseTwo.data).error) return parseApexLikeResponse(responseTwo.data);
    // if (parseApexLikeResponse(responseTwo.data).error)  throw new Error(responseOne.data);
    const responseThree = await axios({
      method: 'post',
      url: URL + 'recibo_pdf',
      data: qs.stringify({
        TOKEN: TOKEN,
        RECIBO_NRO: responseTwo.data.items[0].recibo,
      }),
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
      responseType: 'blob',
    });
    // console.log(responseThree.data);
    // if (responseThree.data.error) return responseThree.data;
    if (responseThree.data.error) throw new Error(responseOne.data);
    return {
      blob: responseThree.data,
      recibo: responseTwo.data.items[0].recibo,
    };
  } catch (error) {
    console.error(error);

    return -1;
  }
};

function parseApexLikeResponse(raw) {
  if (typeof raw !== "string") return raw;
  const i = raw.indexOf("{");
  if (i === -1) return raw;
  const candidate = raw.slice(i).trim();
  try { return JSON.parse(candidate); } catch { return raw; }
}

export const getQr = async (recibo) => {
  try {
    const response = await axios({
      method: 'get',
      // url: 'https://weblogin.muninqn.gov.ar/api2/ReciboTasas/' + recibo,
      url: 'https://api.muninqn.gov.ar/prod/ReciboTributario/' + recibo,
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
    });

    if (response.data.value.error) return -1;

    // return response.data.value.qrImage;
    return response.data.value;
  } catch (error) {
    return -1
  }
}
